<template>
  <div class="pfixed custome"  style="overflow: hidden;width: 250px;">
    <div class="item" id = 'videoid'>
      <video width="100%"     poster="@/assets/images/videoimg.png" @click="videos()">
        <source src="https://enroll-1309900867.cos.ap-shanghai.myqcloud.com/upload_files/3j.m4v" type="video/ogg">
      </video>
      <div class="titlevideo">宁波第三技工学校宣传片</div>
    </div>

    <div v-if="showvideo" class="msgvideo">
      <div  style="position: absolute;right: 10px;top: 30px;z-index: 99999">
        <img src="@/assets/images/clone.png" width="35" @click="clone()">
      </div>
      <video width="1000" height="620" controls    poster="@/assets/images/videoimg.png" >
        <source src="https://enroll-1309900867.cos.ap-shanghai.myqcloud.com/upload_files/3j.m4v" type="video/ogg">
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: "Publicize",
  data(){
    return{
      num:0,
      showvideo:false
    }
  },
  props:[
    'filevideo'
  ],
  created(){
  },methods:{
    clone(){
      this.showvideo=false
    },
    videos(){
      this.showvideo = true
      // let data = document.getElementsByTagName('video')
      // // document.getElementById('videoid').style.filter = 'blur(5px)'
      // data[0].play()
    },
  }
}
</script>

<style scoped>
.msgvideo{
  position: fixed;top: 15%;left: 22%;border-radius: 15px;
}
.titlevideo{
  font-size: 18px;text-align: center;font-weight: bolder;background-color: #364797;color: white;width: 250px;line-height: 30px;
  margin-top: -5px;border-radius: 3px;
  margin-bottom: 2px;
  font-family: 仿宋;
}
.custome{bottom: 0;right: 2px;z-index: 888;}
</style>



// WEBPACK FOOTER //
// src/components/Publicize.vue